<div class="cc-tile-with-backBtn">
  <div id="addClientButton" class="title-backBtn" (click)="backToTenantGrid()"><span class="fas fa-long-arrow-alt-left"></span></div>
  <h3>{{'_General_Add_Client_Text_' | translate }}</h3>
</div>

<div class="cc-single-tab">
  <form [formGroup]="tenantCreationForm" (ngSubmit)="saveTenant()">
    <section class="cc-section-wrapper">
      <div>
        <div>
          <h6 class="sub-heading">{{'_General_Basic_Settings_Text_' | translate }}</h6>
        </div>

        <!--Client Code-->
        <div class="row">
          <div class="col-md-4 input">
            <label for="TenantCode" class="required">{{'_General_Client_Code_Text_' | translate }}
              <span tabindex="-1" class="required-field">*</span>
            </label>
            <input id="TenantCode" class="form-control" type="text" maxlength="30" (focusout)="onFocusOutClientCode()" (keyup)="onChangeClientCode()" formControlName="clientCode" app-filter pattern="^((?=[\x20-\x7E\s])[A-Za-z0-9])*$">
            <div *ngIf="clientCode?.invalid && (clientCode?.dirty || clientCode?.touched)">
              <div class="cc-validation" *ngIf="clientCode?.errors?.required">
                {{'_Clients_Client_Code_Required_Validation_Text_' | translate }}
              </div>
            </div>
            <div *ngIf="(clientCode?.dirty || clientCode?.touched)">
              <div class="cc-validation" *ngIf="clientCodeAlreadyUsed">
                {{'_Clients_Client_Code_Already_Using_Validation_Text_' | translate }}
              </div>
            </div>
          </div>

          <!--Client Name-->
          <div class="col-md-4 input">
            <label for="TenantName" class="required">{{'_General_Client_Name_Text_' | translate }}
              <span tabindex="-1" class="required-field">*</span>
            </label>
            <input id="TenantName" class="form-control" type="text" maxlength="100" formControlName="clientName"
              maxlength="100" app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$"
              (focusout)="onFocusOutClientName()" (keyup)="onChangeClientName()">

            <div *ngIf="clientName?.invalid && (clientName?.dirty || clientName?.touched)">
              <div class="cc-validation" *ngIf="clientName?.errors?.required">
                {{'_Clients_Client_Name_Required_Validation_Text_' | translate }}
              </div>
            </div>

            <div *ngIf="(clientName?.dirty || clientName?.touched)">
              <div class="cc-validation" *ngIf="clientNameAlreadyUsed">
                {{'_Clients_Client_Name_Already_Using_Validation_Text_' | translate }}
              </div>
            </div>
          </div>

          <!--Solution ID-->
          <div class="col-md-4 input">
            <label for="SolutionId" class="required">{{'_General_Solution_Id_Text_' | translate }}
              <span tabindex="-1" class="required-field">*</span>
            </label>
            <input id="SolutionID" class="form-control" type="text" maxlength="50" formControlName="clientSolutionId"
              maxlength="50" app-filter pattern="^((?=[\x20-\x7E\s])[A-Za-z0-9])*$" (focusout)="onFocusOutSolutionId()"
              (keyup)="onChangeClientSolutionId()">

            <div *ngIf="clientSolutionId?.invalid && (clientSolutionId?.dirty || clientSolutionId?.touched)">
              <div class="cc-validation" *ngIf="clientSolutionId?.errors?.required">
                {{'_Clients_Solution_ID_Required_Validation_Text_' | translate }}
              </div>
            </div>

            <div *ngIf="(clientSolutionId?.dirty || clientSolutionId?.touched)">
              <div class="cc-validation" *ngIf="solutionIdAlreadyUsed">
                {{'_Clients_Solution_ID_Already_Using_Validation_Text_' | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 input">
            <label for="DomainName" class="required">{{'_Clients_Default_Domain_Name_Label_Text_' | translate }}
              <span tabindex="-1" class="required-field">*</span>
            </label>
            <input id="DomainName" class="form-control" type="text" maxlength="100" formControlName="domainName"
              (focusout)="onFocusOutDomainName()" (keyup)="onChangeDomainName()"
              (paste)="onPasteInputChange('domainName')" (keypress)="omit_special_char($event)">
            <div *ngIf="domainName?.invalid && (domainName?.dirty || domainName?.touched)">
              <div class="cc-validation" *ngIf="domainName?.errors?.required">
              {{'_Clients_Default_Domain_Name_Required_Validation_Text_' | translate }}
              </div>
            </div>
             <div *ngIf="domainName?.invalid && (domainName?.dirty || domainName?.touched)">
              <div class="cc-validation" *ngIf="domainName?.errors?.pattern">
              {{'_System_Configuration_Invalid_Domain_Name_Ts_Text_' | translate }}
              </div>
            </div>
            
            <div *ngIf="(domainName?.dirty || domainName?.touched)">
              <div class="cc-validation" *ngIf="defaultDomainNameAlreadyUsed">
                {{'_Clients_Default_Domain_Name_Already_Using_Validation_Text_' | translate }}
              </div>
            </div>

          </div>

          <!--Migrated Client-->
          <div class="col-md-8 checkbox d-flex align-items-center">
            <label>
              <input _ngcontent-rls-c23="" class="cc-filter-checkbox k-checkbox" formcontrolname="IsMigratedClient"
                id="MigratedClient" kendocheckbox="" type="checkbox" (click)="OnMigratedClientClick($event)">
                {{'_Tenant_Creation_Migrated_Client_Text_' | translate}}
            </label>
          </div>
        </div>
      </div>
    </section>
    <section class="cc-section-wrapper">
      <div>
        <div>
          <h6 class="sub-heading">{{'_Clients_Database_Settings_Label_Text_' | translate }}</h6>
        </div>

        <div class="row">
          <div class="col-md-4 input">
            <label for="selectServerName"> {{'_General_Server_Name_Text_' | translate }}</label>

            <select class="cc-select-dropdown form-control" id="selectServerName" placeholder="Select"
              formControlName="clientServerName">
              <option *ngFor="let server of serverList">{{server}}</option>
            </select>
          </div>

          <div class="col-md-8 db-name input">
            <label>{{'_General_Database_Name_Text_' | translate }}</label>
            <label id="clientDatabaseName" name="clientDatabaseName" class="cc-value-label">{{databaseName}}</label>
          </div>
        </div>
      </div>
    </section>

    <!-- Button Panel -->
    <div class="cc-btn-panel">
      <button type="button" class="btn btn-secondary" (click)="backToTenantGrid()">Cancel</button>
      <button type="submit" class="btn btn-primary"
        [disabled]="!tenantCreationForm.valid || !tenantCreationForm.dirty || clientCodeAlreadyUsed || clientNameAlreadyUsed || solutionIdAlreadyUsed || defaultDomainNameAlreadyUsed">Save</button>
    </div>
  </form>
</div>